import { createContext, useState, useEffect, Children } from "react";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
// import jwt_decode from 'jwt-decode'
import { jwtDecode } from 'jwt-decode';
import {useNavigate} from 'react-router-dom'

const AuthContext = createContext()


export default AuthContext;



export const AuthProvider = ({children}) => {

    
    // let tokenRefreshTime = 1000 * 60 * 4 
    let tokenRefreshTime = 840000
    let [authTokens, setAuthTokens] = useState(() => localStorage.getItem('authTokens') ? JSON.parse(localStorage.getItem('authTokens')) : null)
    let [user, setUser] = useState(() => localStorage.getItem('authTokens') ? jwtDecode(localStorage.getItem('authTokens')) : null)
    let [loading, setLoading] = useState(true)
    const [open, setOpen] = useState(false); // Snackbar
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // 'success' | 'error' | 'info' | 'warning'

    const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
    };

    const navigate = useNavigate()

    let loginUser = async (userId,passcode ) =>{
        // e.preventDefault();
        // console.log('Form submitted')
        // const api_link = 'http://127.0.0.1:8000/api/token/';
        const api_link = 'https://api.mba-gris.stgafrica.org/api/token/'
        let response = await fetch(api_link, {
            method:'POST',
            headers:{
                'Content-Type':'application/json'
            }, 
            body:JSON.stringify({'username':userId, 'password':passcode})
          })
          let data = await response.json()
          
        if(response.status === 200){
            setAuthTokens(data)
            setUser(jwtDecode(data.access))
            localStorage.setItem('authTokens', JSON.stringify(data)) 
            setSnackbarMessage('Login successful! Redirecting...');
          setSnackbarSeverity('success');
          setOpen(true);
          setTimeout(() => {
            navigate('/')
            // window.location.href = '/selection';
          }, 2000);
            // navigate('/')
            return response.status
        }else if (response.status === 401) {
          setSnackbarMessage('Invalid credentials. Please try again.');
          setSnackbarSeverity('error');
          setOpen(true);
          setLoading(false);
          return response.status
          
          }
          
          // alert('Invalid credentials. Please check your username and passcode.');
        else{
          alert('Theres ')
          setSnackbarMessage('There is something wrong. Contact Admin.');
          setSnackbarSeverity('error');
          setOpen(true);
          setLoading(false);
          return response.status
        }
    } 


    let logOutUser = () => {
        setAuthTokens(null)
        setUser(null)
        localStorage.removeItem('authTokens')
        navigate('/login')
    }


    let updateToken = async () => {
        console.log('Update token called')
        // const api_link = 'http://127.0.0.1:8000/api/token/refresh/';
        const api_link = 'https://api.mba-gris.stgafrica.org/api/token/refresh/'
      let response = await fetch(api_link, {
            method:'POST',
            headers:{
                'Content-Type':'application/json'
            }, 
            body:JSON.stringify({'refresh':authTokens?.refresh})
        })
        let data = await response.json()  
            if(response.status === 200){
                let newTokens = {
            access: data.access,
            refresh: data.refresh ?? authTokens.refresh, // <- preserve original refresh
            }
            setAuthTokens(newTokens)
            setUser(jwtDecode(data.access))
            localStorage.setItem('authTokens', JSON.stringify(newTokens)) 
            // navigate('/dashboard')
        }else{
            logOutUser()
        }
        if(loading){
            setLoading(false)
        }
    }


    let contextData = {
        user:user, 
        authTokens:authTokens,
        loginUser:loginUser,
        logOutUser:logOutUser, 

        // loginUser
    }


    // useEffect(()=>{
    //     if(loading){
    //         updateToken()
    //     }

    //     let interval = setInterval(()=>{
    //         if(authTokens){
    //             updateToken()
    //         }
    //     },tokenRefreshTime )
    //     return ()=> clearInterval(interval)
    // }, [authTokens, loading])

    useEffect(() => {
  const tryUpdate = () => {
    if (authTokens?.refresh) {
      updateToken();
    } else {
      // If no refresh token, just stop loading and show the app (e.g., login screen)
      setLoading(false);
    }
  };

  if (loading) {
    tryUpdate();
  }

  const interval = setInterval(() => {
    if (authTokens?.refresh) {
      updateToken();
    }
  }, tokenRefreshTime);

  return () => clearInterval(interval);
}, [authTokens, loading]);


    return(
        <>        
        <AuthContext.Provider value={contextData}>
            {loading ? <div>Loading...</div> : children}
        </AuthContext.Provider>

        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={snackbarSeverity} variant="filled" sx={{ width: '100%' }}>
                  {snackbarMessage}
                </Alert>
        </Snackbar>
        </>
        
    )
};